import { LegalLayout } from '../components/LegalLayout';
import '../legal.css';

export function CookiesPage() {
  return (
    <LegalLayout
      title="Cookies & Local Storage"
      updated="May 7, 2026"
      summary="Rynora keeps cookies and local storage to a minimum. We use them only to remember your session and your theme. No third-party trackers."
    >
      <h2>What we set</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Purpose</th>
            <th>Lifetime</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>rynora_token</code>
            </td>
            <td>Local storage</td>
            <td>Holds your authentication token after login.</td>
            <td>Until logout or expiry (30 days).</td>
          </tr>
          <tr>
            <td>
              <code>rynora-theme</code>
            </td>
            <td>Local storage</td>
            <td>Remembers whether you picked light, dark, or system theme.</td>
            <td>Until you clear it.</td>
          </tr>
          <tr>
            <td>
              <code>rynora_org_id</code>
            </td>
            <td>Local storage</td>
            <td>Remembers your last-active organization.</td>
            <td>Until you clear it.</td>
          </tr>
          <tr>
            <td>
              <code>connect.sid</code>
            </td>
            <td>Cookie (HttpOnly)</td>
            <td>SSO callback flow only — set when you authenticate via SAML / OIDC.</td>
            <td>Session.</td>
          </tr>
        </tbody>
      </table>

      <h2>What we don't set</h2>
      <ul>
        <li>No third-party advertising trackers.</li>
        <li>No fingerprinting beacons.</li>
        <li>No analytics cookies for the marketing site (we use Cloudflare server-side analytics).</li>
      </ul>

      <h2>Managing them</h2>
      <p>
        You can clear all of the above by clearing local storage / cookies for <code>rynora.app</code> in your browser.
        Doing so will sign you out and reset your theme preference to "system".
      </p>

      <h2>Questions</h2>
      <p>
        Email <a href="mailto:support@rynora.app">support@rynora.app</a>.
      </p>
    </LegalLayout>
  );
}
